import { Redirect } from 'expo-router';
import { Platform } from 'react-native';
import ProfileNotification from '@/screens/ProfileNotification';

export default function PrivateProfileNotificationRoute() {
  if (Platform.OS === 'web') {
    return <Redirect href="/profile" />;
  }

  return <ProfileNotification />;
}
